<template>
  <div class='xy-content-module'>
    <van-nav-bar fixed>
        <!-- <div slot="left" @click="close" class="icon-title-line">
            <van-icon name="arrow-left" color="#333" class="icon-title-size" />
        </div> -->
         <div slot="title" class="all-title">发送成功</div>
    </van-nav-bar>
    <div class='xy-content-body'>
        <div class="tips-content">
            <img style="width:20%;height:20%" src="@/assets/schoolAffairs/success1.png" alt="图片"/>
            <p>您的邀请信息已发送</p>
        </div>
        <div class="tips-button">
            <van-button round block type="default" @click="arriveList" native-type="submit" style="margin-right:5px;border: 1px solid #ccc;" >
              返回列表
            </van-button>
            <van-button round block type="info" @click="arriveDetails" native-type="submit" style="margin-left:5px;background:#1677FF">
              查看详情
            </van-button>
        </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: '',
    data () {
      return {
      }
    },
    created () {},
    mounted () {},
    methods :{
        arriveList(){
            this.$router.go(-2);
        },
        arriveDetails(){
            this.$router.push({
              path: "/home/LaunchInvitationDetails",
              query: {
                isFrom: "invitationBuild"
              }
            });
        }
    }
  }
</script>
<style lang='less' scoped>
.xy-content-module{
    .xy-content-body{
        width: 100%;
        height: auto;
        .tips-content{
            padding-top:200px;
            text-align: center;
            font-size: 32px;
            color: #333333;
            p{
                margin-top: 50px;
            }
        }
        .tips-button{
            margin: 16px;
            display: flex;
            justify-content: center;
            margin-top:120px;
            button {
                width:36%;
                font-size: 30px;
            }
        }
    }
}
.icon-title-line{
  display: flex;
  align-items: center;
}
.icon-title-size{
  font-size: 38px;
}
</style>
